import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import { salesCalculateReportExl } from 'lib/api/sales';
import { makeRowColumn, getHeadObj } from 'lib/commonLib';
import { dataConverter } from 'lib/commonLib';
import NewTableContainer from 'components/molecules/NewTable';
import SpanningTableContents from 'components/molecules/MbTable/SpanningTableContents';
import NewFilterWrap from 'components/molecules/NewFilterWrap';
import NewCommonFilter from 'components/organisms/NewCommonFilter';
import FilterCollection from 'components/organisms/FilterCollection';
import NewButton from 'components/molecules/NewButton';
import CalculateModal from './CalculateModal';
import queryString from 'query-string';
import numeral from 'numeral';

const ReportExl = ({ location }) => {
  const { t } = useTranslation();

  const convertKeys = ['adutSvcDtlTpCode', 'statsMth'];
  const newInitParams = dataConverter(
    queryString.parse(location.search),
    convertKeys
  );

  const initList = {
    mobonFlag: [
      { label: '제외', value: 'all' },
      { label: '포함', value: '01' },
    ],
  };

  let initParams = {
    //statsMth: moment().format('YYYYMM'),
    mobonFlag: 'all',
  };

  let newParams;
  if (typeof newInitParams.adutSvcDtlTpCode !== 'undefined') {
    newParams = {
      table: 'sub',
    };
  }

  initParams = {
    ...initParams,
    ...newParams,
    ...newInitParams,
  };

  let initModal = {
    open: false,
    type: null,
    params: {},
    modalTitle: '',
    confirmBtnTitle: '',
    message: '',
  };

  const [initialization, setInitialization] = useState(false);
  const [params, setParams] = useState(initParams);
  const [modal, setModal] = useState(initModal);
  const [reFetch, setReFetch] = useState(false);

  useEffect(() => {
    if (initialization === true) {
      setInitialization(false);
    }
  }, [initialization]);

  const getModalParam = (newParams) => {
    if (JSON.stringify(modal) !== JSON.stringify(newParams)) {
      setModal(newParams);
    }
  };

  const getParam = (newParams) => {
    if (JSON.stringify(params) !== JSON.stringify(newParams)) {
      setParams(newParams);
    }
  };

  const handleOnReset = () => {
    setInitialization(true);
    setParams(initParams);
  };

  /**
   * 테이블 상태를 갱신
   * @param status
   */
  const handleReFetch = (status) => {
    setReFetch(status);
  };

  /**
   * 모달 닫아주는 함수
   */
  const handleModalClose = () => {
    let newModal;
    newModal = {
      ...modal,
      open: false,
    };
    getModalParam(newModal);
  };

  /**
   * modal 열어주는 함수
   */
  const handleModalOpen = (e, data) => {
    const { name } = e.currentTarget;
    let newModal = { ...initModal };

    if (name === 'endPriceEdit') {
      newModal = {
        ...newModal,
        open: true,
        type: name,
        modalTitle: '금액관리',
        confirmBtnTitle: '수정',
        params: {
          ...modal.params,
          adutSvcDtlTpCode: data['ADUT_SVC_DTL_TP_CODE'],
          statsMth: data['STATS_MTH'],
          dtlItlId: data['DTL_ITL_ID'],
          dlOrderAmtUs: data['DL_ORDER_AMT_US'],
          rsnAmt: data['INTRCP_RSN_AMT'],
        },
      };
    }
    setModal(newModal);
  };

  /**
   * 테이블 컬럼 추가
   */
  const addColumnList = (() => {
    const result = new Map();
    result.set(-1, {
      id: 'memoEdit',
      label: t('관리'),
      align: 'center',
      makeRowFunc: (data) => {
        let resultData;
        if (data.EXL_NM !== 'total') {
          resultData = (
            <NewButton
              name="endPriceEdit"
              title={t('수정')}
              iconBtn
              icon="faEdit"
              onClick={(e) => handleModalOpen(e, data)}
              disableRipple
            />
          );
        }

        return resultData;
      },
    });
    return result;
  })();

  const customized = {
    default: {
      EXL_NM: {
        makeHead: () => {
          return t('연동사명');
        },
        makeBody: (rowObj, headsMap) => {
          const roas = getHeadObj(headsMap, 'EXL_NM');
          return <>{makeRowColumn(rowObj['EXL_NM'], roas.type, roas.format)}</>;
        },
      },
      TAX_NO: {
        makeHead: () => {
          return t('사업자번호');
        },
        makeBody: (rowObj, headsMap) => {
          const roas = getHeadObj(headsMap, 'TAX_NO');
          return <>{makeRowColumn(rowObj['TAX_NO'], roas.type, roas.format)}</>;
        },
      },
      PRDT_NM: {
        makeHead: () => {
          return t('품목');
        },
        makeBody: (rowObj, headsMap) => {
          const roas = getHeadObj(headsMap, 'PRDT_NM');
          return (
            <>{makeRowColumn(rowObj['PRDT_NM'], roas.type, roas.format)}</>
          );
        },
      },
      // STATS_MTH: {
      //   makeHead: () => {
      //     return t('작성일자');
      //   },
      //   makeBody: (rowObj, headsMap) => {
      //     const roas = getHeadObj(headsMap, 'STATS_MTH');
      //     return (
      //       <>{makeRowColumn(rowObj['STATS_MTH'], roas.type, roas.format)}</>
      //     );
      //   },
      // },
      SUP_PRICE: {
        makeHead: () => {
          return t('공급가액');
        },
        makeBody: (rowObj, headsMap) => {
          const roas = getHeadObj(headsMap, 'SUP_PRICE');
          return (
            <>{makeRowColumn(rowObj['SUP_PRICE'], roas.type, roas.format)}</>
          );
        },
      },
      CALCUL_VAT: {
        makeHead: () => {
          return t('세액');
        },
        makeBody: (rowObj, headsMap) => {
          const roas = getHeadObj(headsMap, 'CALCUL_VAT');
          return (
            <>{makeRowColumn(rowObj['CALCUL_VAT'], roas.type, roas.format)}</>
          );
        },
      },
      TOTAL_PRICE: {
        makeHead: () => {
          return t('합계액');
        },
        makeBody: (rowObj, headsMap) => {
          const roas = getHeadObj(headsMap, 'TOTAL_PRICE');
          return (
            <>{makeRowColumn(rowObj['TOTAL_PRICE'], roas.type, roas.format)}</>
          );
        },
      },
      DEPOSIT_AMT: {
        makeHead: () => {
          return t('입금액');
        },
        makeBody: (rowObj, headsMap) => {
          const roas = getHeadObj(headsMap, 'DEPOSIT_AMT');
          return (
            <>{makeRowColumn(rowObj['DEPOSIT_AMT'], roas.type, roas.format)}</>
          );
        },
      },
      STATS_MTH: {
        merged: true,
      },
      ADUT_SVC_DTL_TP_CODE: {
        merged: true,
      },
    },
    sub: {
      EXL_NM: {
        makeHead: () => {
          return t('연동사명');
        },
        makeBody: (rowObj, headsMap) => {
          const roas = getHeadObj(headsMap, 'EXL_NM');
          return <>{makeRowColumn(rowObj['EXL_NM'], roas.type, roas.format)}</>;
        },
      },
      ORDER_AMT_KR: {
        makeHead: () => {
          const result = { content: '', orderFlag: true };
          result.content = (
            <SpanningTableContents topTitle={t('원화')} type="head">
              <div style={{ width: 100 }}>{t('매출(KRW)')}</div>
            </SpanningTableContents>
          );
          return result;
        },
        makeBody: (rowObj) => {
          return (
            <SpanningTableContents>
              <div style={{ width: 100 }}>
                {numeral(rowObj['ORDER_AMT_KR']).format('#,##0')}
              </div>
            </SpanningTableContents>
          );
        },
        orderFlag: false,
        headStyle: {
          borderLeft: '1px solid #e5e8eb',
          borderRight: '1px solid #e5e8eb',
        },
        bodyStyle: {
          borderLeft: '1px solid #e5e8eb',
          borderRight: '1px solid #e5e8eb',
        },
      },

      ORDER_AMT_US: {
        makeHead: () => {
          const result = { content: '', orderFlag: true };
          result.content = (
            <SpanningTableContents topTitle={t('외화')} type="head">
              <div style={{ width: 100 }}>{t('매출(USD)')}</div>
              <div style={{ width: 100 }}>{t('마감금액')}</div>
            </SpanningTableContents>
          );
          return result;
        },
        makeBody: (rowObj) => {
          return (
            <SpanningTableContents>
              <div style={{ width: 100 }}>
                {numeral(rowObj['ORDER_AMT_US']).format('#,##0')}
              </div>
              <div style={{ width: 100 }}>
                {numeral(rowObj['DL_ORDER_AMT_US']).format('#,##0')}
              </div>
            </SpanningTableContents>
          );
        },
        orderFlag: false,
        headStyle: {
          borderRight: '1px solid #e5e8eb',
        },
        bodyStyle: {
          borderRight: '1px solid #e5e8eb',
        },
      },
      DL_ORDER_AMT_US: {
        merged: true,
      },

      ACC_ORDER_AMT: {
        makeHead: () => {
          return t('회계매출(원화+외화마감금액)');
        },
        makeBody: (rowObj, headsMap) => {
          const roas = getHeadObj(headsMap, 'ACC_ORDER_AMT');
          return (
            <>
              {makeRowColumn(rowObj['ACC_ORDER_AMT'], roas.type, roas.format)}
            </>
          );
        },
      },
      INTRCP_RSN_AMT: {
        makeHead: () => {
          return t('비고액(+/-)');
        },
        makeBody: (rowObj, headsMap) => {
          const roas = getHeadObj(headsMap, 'INTRCP_RSN_AMT');
          return (
            <>
              {makeRowColumn(rowObj['INTRCP_RSN_AMT'], roas.type, roas.format)}
            </>
          );
        },
      },
      CF_AMT: {
        makeHead: () => {
          return t('확정매출(회계매출+비고액)');
        },
        makeBody: (rowObj, headsMap) => {
          const roas = getHeadObj(headsMap, 'CF_AMT');
          return <>{makeRowColumn(rowObj['CF_AMT'], roas.type, roas.format)}</>;
        },
      },
      DTL_ITL_ID: {
        merged: true,
      },
      STATS_MTH: {
        merged: true,
      },
      ADUT_SVC_DTL_TP_CODE: {
        merged: true,
      },
    },
  };

  return (
    <>
      <NewFilterWrap handleOnReset={handleOnReset}>
        <NewCommonFilter
          initialization={initialization}
          getParam={getParam}
          params={params}
          usePltfomTpCodeFilter={false}
          useDisplayFilter={false}
          useExternalFilter={false}
          useSingleDate
          useMonthDate
          singleDateId={'statsMth'}
        />
        {params.adutSvcDtlTpCode === '02' && (
          <FilterCollection
            label={t('모비온 소진금액 60%')}
            name="mobonFlag"
            params={params}
            value={params.mobonFlag}
            type="radio"
            list={initList.mobonFlag}
            callBack={getParam}
            labelKey="label"
            valueKey="value"
          />
        )}
      </NewFilterWrap>
      <NewTableContainer
        dataReqPromise={salesCalculateReportExl}
        params={params}
        getParam={getParam}
        customized={
          params.adutSvcDtlTpCode === 'all'
            ? customized.default
            : customized.sub
        }
        useSearch={true}
        useTotal={true}
        reFetch={reFetch}
        addColumnList={
          typeof params.adutSvcDtlTpCode !== 'undefined'
            ? addColumnList
            : new Map()
        }
      />
      {modal.open === true && (
        <CalculateModal
          modal={modal}
          handleReFetch={handleReFetch}
          getModalParam={getModalParam}
          handleModalClose={handleModalClose}
        ></CalculateModal>
      )}
    </>
  );
};

export default withRouter(ReportExl);
